import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ClarifyDetailStatus, ClarifyMainStatus, ClarifyPriority } from '@/types/clarify';

const MAIN_STATUS_LABELS: Record<ClarifyMainStatus, string> = {
  request: 'Request',
  in_progress: 'In Progress',
  in_review: 'In Review',
  solved: 'Solved',
};

const MAIN_STATUS_CLASSES: Record<ClarifyMainStatus, string> = {
  request: 'border-amber-200 bg-amber-50 text-amber-700',
  in_progress: 'border-sky-200 bg-sky-50 text-sky-700',
  in_review: 'border-violet-200 bg-violet-50 text-violet-700',
  solved: 'border-emerald-200 bg-emerald-50 text-emerald-700',
};

const DETAIL_STATUS_LABELS: Record<ClarifyDetailStatus, string> = {
  request: 'Neu',
  qualified: 'Qualifiziert',
  assigned: 'Zugewiesen',
  accepted: 'Akzeptiert',
  interview_in_progress: 'Interview aktiv',
  awaiting_input: 'Wartet auf Input',
  submitted: 'Eingereicht',
  review_in_progress: 'Review aktiv',
  revision_requested: 'Nacharbeit',
  solved: 'Geloest',
  rejected: 'Abgelehnt',
  cancelled: 'Abgebrochen',
  expired: 'Abgelaufen',
};

const PRIORITY_LABELS: Record<ClarifyPriority, string> = {
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch',
  critical: 'Kritisch',
};

const PRIORITY_CLASSES: Record<ClarifyPriority, string> = {
  low: 'border-slate-200 bg-slate-100 text-slate-700',
  medium: 'border-stone-200 bg-stone-100 text-stone-700',
  high: 'border-orange-200 bg-orange-50 text-orange-700',
  critical: 'border-rose-200 bg-rose-50 text-rose-700',
};

interface BadgeProps {
  className?: string;
}

export function ClarifyMainStatusBadge({ status, className }: { status: ClarifyMainStatus } & BadgeProps) {
  return (
    <Badge variant="outline" className={cn('text-xs', MAIN_STATUS_CLASSES[status], className)}>
      {MAIN_STATUS_LABELS[status]}
    </Badge>
  );
}

export function ClarifyDetailStatusBadge({ status, className }: { status: ClarifyDetailStatus } & BadgeProps) {
  return (
    <Badge variant="outline" className={cn('text-xs', className)}>
      {DETAIL_STATUS_LABELS[status]}
    </Badge>
  );
}

export function ClarifyPriorityBadge({ priority, className }: { priority: ClarifyPriority } & BadgeProps) {
  return (
    <Badge variant="outline" className={cn('text-xs', PRIORITY_CLASSES[priority], className)}>
      {PRIORITY_LABELS[priority]}
    </Badge>
  );
}